import React from 'react'
import { useSelector } from 'react-redux'

import CallDialog from '@/app/component/atom/call-dialog'
import { selectToken } from '@/app/module/auth/store/selectors'
import { useGetCallerOptions } from '@/app/module/common/hooks/use-get-caller-options'
import { toggleCallDialog } from '@/app/module/user/store/actions'
import { selectOrgId } from '@/app/module/user/store/selectors'
import { RootState } from '@/app/store'
import { useAppDispatch } from '@/app/store/redux-hooks'

type Props = {}

const CallDialogContainer: React.FC<Props> = () => {
  const dispatch = useAppDispatch()

  const callDialog = useSelector((state: RootState) => state.user.callDialog)
  const { callerIds } = useGetCallerOptions()
  const orgId = useSelector(selectOrgId)
  const token = useSelector(selectToken)

  const closeDialog = React.useCallback(
    () =>
      dispatch(
        toggleCallDialog({
          autoStart: false,
          isOpen: false,
          contactId: undefined,
          contactName: undefined,
          subId: undefined,
        }),
      ),
    [dispatch],
  )

  if (!callDialog?.contactId || !callDialog?.isOpen) {
    return null
  }

  return (
    <CallDialog
      autoStart={Boolean(callDialog.autoStart)}
      callerIds={callerIds}
      contactId={callDialog.contactId}
      contactName={callDialog.contactName}
      orgId={orgId}
      subId={callDialog.subId}
      token={token || ''}
      onClose={closeDialog}
    />
  )
}

export default CallDialogContainer
